import request from '@/utils/request'

export function getPageList(data) {
    return request({
        url: 'comment/getPageList',
        method: 'post',
        data
    })
}

export function syncComments(data) {
    return request({
        url: 'comment/SyncComments',
        method: 'post',
        data
    })
}

export function addDesc(data) {
    return request({
        url: 'comment/addDesc',
        method: 'post',
        data
    })
}